import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { profile, devConfig } from 'config/config'; // Importing profile state and development configuration

/**
 * Filter panel for the "Reporte de Depósitos por Franquicias" report.
 * @extends JetView
 */
export default class FilterDepositReportFranchiseView extends JetView {
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        
        let franchiseSearchId = 0;
        let productSearchId = 0;
        // Left column of filters
        const left = {
            margin: 5,
            id: 'a1franchise',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1franchise',
                    cols: [
                        {
                            view: 'text', // Date range input 
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker', // Single day input, used instead of Datepicker
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(),
                                },
                            },
                        },
                        {
                            // Live search against Select/FranchiseSelect
                            view: 'combo',
                            name: 'FranchiseId',
                            minWidth: 200,
                            label: "<span class='icon-shop'></span>" + _('Franquicia'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            const requestId = ++franchiseSearchId;
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/FranchiseSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            // Ignore responses superseded by a newer keystroke
                                                            if (!resp.HasError && requestId === franchiseSearchId) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        } else {
                                            franchiseSearchId++;
                                            vthis.clearAll();
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'text', // Numeric input for the deposit's user id
                            name: 'UserId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-user'></span>" + _('ID Usuario'),
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'richselect', // Deposit status filter
                            name: 'Status',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Estado del Depósito'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'ALL', value: _('Todos') }, // Mapped to Status:null in buildRequestPayload
                                { id: 'A', value: _('Pagada') },
                                { id: 'C', value: _('Cancelado') },
                                { id: 'I', value: _('Inactivo') },
                                { id: 'E', value: _('Enviada') },
                                { id: 'EX', value: _('Expirada') },
                                { id: 'R', value: _('Rechazada') },
                                { id: 'P', value: _('Pendiente') },
                            ],
                        },
                    ],
                },
            ],
        };
        // Right column of filters
        const left2 = {
            margin: 5,
            id: 'a2franchise',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2franchise',
                    cols: [
                        {
                            // Options loaded once in init()
                            view: 'combo',
                            name: 'PaymentProviderId',
                            id: 'PaymentProviderId',
                            minWidth: 260,
                            label: _('Proveedor pasarela de pago'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            // Live search against Select/PaymentSystemsSelect
                            view: 'combo',
                            name: 'PaymentProductId',
                            minWidth: 200,
                            label: "<span class='icon-credit-card'></span>" + _('Producto de Pago'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            const requestId = ++productSearchId;
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/PaymentSystemsSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            // Ignore responses superseded by a newer keystroke
                                                            if (!resp.HasError && requestId === productSearchId) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        } else {
                                            productSearchId++;
                                            vthis.clearAll();
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'text', // Minimum deposit amount
                            name: 'MinAmount',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Valor Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Valor Mínimo'),
                        },
                        {
                            view: 'text', // Maximum deposit amount
                            name: 'MaxAmount',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Valor Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Valor Máximo'),
                        },
                        {
                            view: 'text', // Deposit IP address
                            name: 'IpAddress',
                            minWidth: 200,
                            label: "<span class='icon-ip'></span>" + _('Dirección IP'),
                            labelPosition: 'top',
                            placeholder: _('Dirección IP'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2franchise',
                    cols: [
                        {
                            view: 'radio', // Switches the table between the grouped summary and the flat detail view
                            name: 'ViewMode',
                            id: 'ViewMode',
                            label: _('Vista'),
                            labelPosition: 'top',
                            minWidth: 200,
                            value: 'SUMMARY',
                            options: [
                                { id: 'SUMMARY', value: _('Resumida') },
                                { id: 'DETAIL', value: _('Detallada') },
                            ],
                        },
                        {},
                    ],
                },
            ],
        };
        // Sort field + sort direction, sent as SortBy/SortMode in the request
        const sortRow = {
            margin: 15,
            css: 'on-row',
            id: 'SortFranchise',
            cols: [
                {
                    view: 'combo', // Field used to sort results
                    name: 'SortBy',
                    label: _('Ordenar por'),
                    labelPosition: 'top',
                    minWidth: 200,
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'UserId', value: _('ID Usuario') },
                        { id: 'Date', value: _('Fecha de Creación') },
                        { id: 'Amount', value: _('Valor') },
                    ],
                    value: 'Date',
                },
                {
                    view: 'combo', // Sort direction
                    name: 'SortMode',
                    label: _('Orden'),
                    labelPosition: 'top',
                    minWidth: 200,
                    options: [
                        { id: 'Asc', value: _('Ascendente') },
                        { id: 'Desc', value: _('Descendente') },
                    ],
                    value: 'Desc',
                },
                { gravity: 1 },
            ],
        };
        // Two-column layout combining left and left2
        const upper_section = {
            css: 'father-container',
            rows: [
                { margin: 10, cols: [left] },
                { margin: 10, cols: [left2] },
            ],
        };
        // Clear and submit actions for the filter form
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Resets all filter fields to their default values
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myFormFranchise').setValues($$('myFormFranchise').getCleanValues());
                    },
                },
                {
                    view: 'button', // Submits the filters and requests the report
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    width: 110,
                    id: 'consultDeskFranchise',
                    click: () => {
                        // Keep only the active date field, then hand the raw form values to the table
                        const filterdata = this.getRoot().getValues();
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                        } else {
                            delete filterdata['Datepicker'];
                        }
                        this.app.callEvent('depositReportFranchise:filter', [filterdata]);
                        $$('b5franchise').collapse();
                        $$('a5franchise').scrollTo(100, 0);
                    },
                },
            ],
        };
        // Collapsible "Filtros" panel wrapping the whole filter form
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5franchise',
                            body: {
                                padding: 10,
                                rows: [upper_section, sortRow, buttons],
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form',
            id: 'myFormFranchise',
            type: 'clean',
            rows: [accordion_section2],
        };
    }

    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Current UI language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Localize the date range picker
        });
        // Sorting only applies to the flat detail view, not the grouped summary treetable
        if ($$('ViewMode').getValue() === 'SUMMARY') {
            $$('SortFranchise').hide();
        }
        $$('ViewMode').attachEvent('onChange', function (newv) {
            if (newv === 'SUMMARY') {
                $$('SortFranchise').hide();
            } else {
                $$('SortFranchise').show();
            }
        });
        // Range vs single-day date input, picked per account setting (profile.typeDate)
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide();
                $$('Datepicker').show();
            } else {
                $$('Date').show();
                $$('Datepicker').hide();
            }
        });
       
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Report/GetProvidersPaymentSystem', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    for (var i = 0; i < resp.Data.length; i++) {
                        resp.Data[i].id = resp.Data[i].Id; // Map backend Id to combo id
                        resp.Data[i].value = resp.Data[i].Name; // Map backend Name to combo value
                    }
                    $$('PaymentProviderId').define('options', resp.Data); // Populate the provider combo
                    $$('PaymentProviderId').refresh();
                },
            });
    }
}

// FILE DOCUMENTED
